export enum StatusPedidoEnum {
  AGUARDANDO_DOCUMENTACAO = 'Aguardando Documentação',
  AGUARDANDO_ANALISE = 'Aguardando Análise',
  EM_ANALISE = 'Em Análise',
  DOCUMENTACAO_PENDENTE = 'Documentação Pendente',
  APTO_PARA_VISTORIA = 'Apta para Vistoria',
  EMITIDO_CI = 'Emitido CI',
  APTO_PARA_EMITIR_CERTIDAO_PODER_CONCEDENTE = 'Apto para emitir cerificado de poder concedente',
  DEFERIDO = 'Deferido',
  INDEFERIDO = 'Indeferido',
  CANCELADO = 'Cancelado',
  APTO_PARA_EXCLUSAO_VEICULO = 'Apto para Exclusão de Veículo',
  APTO_PARA_PARA_RENOVACAO_DE_TRANSPORTADORA = 'Apto para Renovação de Transportadora',
  APTO_PARA_CADASTRO_DE_TRANSPORTADORA = 'Apto para Cadastro de transportadora',
  APTO_PARA_SUBSTITUICAO_COOPERADO = 'Apto para Substituição de Cooperado',
}
